import React from "react";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import Button from "../../../componentLibrary/Button";
import { ComponentI } from "../../../types";
import { useNotification } from "../../../hooks/useNotification";
import { onCopyClipboard } from "./onCopyClipboard";

export const CopyVariableButton = ({
  component,
  type,
  className,
  size = "md",
  label = "Copy",
  title,
}: {
  component: ComponentI;
  type: "icon" | "text" | "icon-text";
  className?: string;
  size?: "xxs" | "sm" | "md" | "lg";
  label?: string;
  title?: string;
}) => {
  const { notify } = useNotification();
  const copyFunction = () => {
    if (component?.content.variable) {
      onCopyClipboard(`{{${component.content.variable}}}`);
      notify("success", "Variable Copied to Clipboard!");
    } else {
      notify("error", "No Variable to copy");
    }
  };
  return type === "icon-text" ? (
    <Button
      variant="dark"
      layout="iconText"
      onClick={copyFunction}
      className={className}
      size={size}
      title={title}
    >
      <ClipboardDocumentListIcon className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{label}</span>
    </Button>
  ) : type !== "icon" ? (
    <Button
      variant="dark"
      onClick={copyFunction}
      className={className}
      size={size}
      title={title}
    >
      {label}
    </Button>
  ) : (
    <Button.Square
      variant="dark"
      className={`p-1 ${className}`}
      title={title}
      onClick={copyFunction}
    >
      <ClipboardDocumentListIcon className="w-6 h-6" />
    </Button.Square>
  );
};
